module.exports = __webpack_public_path__ + "ff2f6a894e5417abfd97b0828d382f14.svg";